import App from 'app/app.js';

// This is a constants object to use for handling mapping to the property used to traverse
// to the unique id of objects cached in array.
var ResourceConstants = {
  mobileNumber: {
    minLength: 10,
    maxLength: 10
  }
};
App.constant('ResourceConstants', ResourceConstants);
